import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import FormatListNumberedOutlinedIcon from '@mui/icons-material/FormatListNumberedOutlined'
import { SectionDefinition } from '../../../components/Sections/Sections.types'

export enum ConditionalStatusGroupSectionIds {
  general = 'general',
  conditions = 'conditions',
}

/**
 * @description Sections shared by the Conditional Status Group detail page and edit form, in display order.
 * `conditions` is read-only on the detail page: conditional statuses are managed in their own tab, so the
 * edit form never renders it.
 */
export const conditionalStatusGroupSections: SectionDefinition[] = [
  {
    id: ConditionalStatusGroupSectionIds.general,
    title: 'General',
    description: 'The name admins see when assigning this group to trails.',
    icon: InfoOutlinedIcon,
  },
  {
    id: ConditionalStatusGroupSectionIds.conditions,
    title: 'Conditional Statuses',
    description: 'Processed in this order. Add or change them in the Conditional Statuses tab below.',
    icon: FormatListNumberedOutlinedIcon,
  },
]
